var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/shield-security"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.905 3.12797L9.78001 1.58297C9.35251 1.42547 8.65501 1.42547 8.22751 1.58297L4.10251 3.12797C3.30751 3.42797 2.66251 4.35797 2.66251 5.20547V11.2805C2.66251 11.888 3.06001 12.6905 3.54751 13.0505L7.67251 16.133C8.40001 16.6805 9.59251 16.6805 10.32 16.133L14.445 13.0505C14.9325 12.683 15.33 11.888 15.33 11.2805V5.20547C15.3375 4.35797 14.6925 3.42797 13.905 3.12797ZM9.56251 9.65297V11.6255C9.56251 11.933 9.30751 12.188 9.00001 12.188C8.69251 12.188 8.43751 11.933 8.43751 11.6255V9.65297C7.68001 9.41297 7.12501 8.70797 7.12501 7.87547C7.12501 6.84047 7.96501 6.00047 9.00001 6.00047C10.035 6.00047 10.875 6.84047 10.875 7.87547C10.875 8.71547 10.32 9.41297 9.56251 9.65297Z",
    fill: "#57A6BD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.a85e8335c81402568e00e4656a2105e2.svg";
export { ForwardRef as ReactComponent };